








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
  @Prop() private name!: string;
  @Prop() private year!: number;
}
